"use strict";

exports.__esModule = true;
exports.SELECT_VEHICLE = exports.SELECT_MODEL = exports.GET_VEHICLE_DATA = exports.GET_ALL_SUB_SPECIFICATION_GROUPS = exports.GET_ALL_SPECIFICATION_GROUPS = exports.GET_ALL_MODELS = exports.DESELECT_VEHICLE = exports.DESELECT_MODEL = exports.CLEAR_VEHICLES_DATA = void 0;
var SELECT_VEHICLE = 'SELECT CAR';
exports.SELECT_VEHICLE = SELECT_VEHICLE;
var DESELECT_VEHICLE = 'DESELECT CAR';
exports.DESELECT_VEHICLE = DESELECT_VEHICLE;
var GET_ALL_MODELS = 'GET ALL MODELS';
exports.GET_ALL_MODELS = GET_ALL_MODELS;
var GET_ALL_SPECIFICATION_GROUPS = 'GET ALL SPECIFICATION GROUPS';
exports.GET_ALL_SPECIFICATION_GROUPS = GET_ALL_SPECIFICATION_GROUPS;
var GET_ALL_SUB_SPECIFICATION_GROUPS = 'GET ALL SUB SPECIFICATION GROUPS';
exports.GET_ALL_SUB_SPECIFICATION_GROUPS = GET_ALL_SUB_SPECIFICATION_GROUPS;
var SELECT_MODEL = 'SELECT MODEL';
exports.SELECT_MODEL = SELECT_MODEL;
var DESELECT_MODEL = 'DESELECT MODEL';
exports.DESELECT_MODEL = DESELECT_MODEL;
var GET_VEHICLE_DATA = 'GET VEHICLE DATA';
exports.GET_VEHICLE_DATA = GET_VEHICLE_DATA;
var CLEAR_VEHICLES_DATA = 'CLEAR VEHICLES DATA';
exports.CLEAR_VEHICLES_DATA = CLEAR_VEHICLES_DATA;